import React from "react";
import { withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";
import orderBy from "lodash/orderBy";
import queryString from "query-string";
import v4 from "uuid/v4";
import Container from "reactstrap/lib/Container";
import { graphql } from "@apollo/client/react/hoc";
import { TARIFFS_QUERY } from "Services/queries";
import { variablesFromRouter } from "Services/QueryBuilder";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import routes from "Configs/routes";
import { newFormList } from "Constants/Tags";
import { LimitPlansBTableContainer } from "Constants/Limit";
import TariffsWithTagList from "Containers/TariffsWithTagList";
import BrandButton from "Containers/Buttons/BrandButton";
import TariffsActualDate from "ComponentsUI/TariffsActualDate";
import { PaddingBottom } from "ComponentsUI/Spacings";
import { TagButton } from "ComponentsUI/Buttons";
import BlockButton from "../components/BlockButton";
import Tariffs from "./containers/Tariffs";
import FiltersContainer from "./containers/Filters";
import Stub from "./containers/Stub";
import { HeaderTextSeo } from "ComponentsUI/SeoBlock";

@inject("ApplicationModel")
@observer
class TarifficationTagsList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			aggregation: null,
			tariffs: null,
			flat: true,
		};
	}

	setOrientation(value) {
		this.setState({
			flat: value,
		});
	}

	onProviderRates(provider) {
		this.props.history.push({
			pathname: generateUrl(routes.ProviderRates.route, {
				providerName: provider.url_name,
				regionUrl: provider.region.url,
			}),
		});
	}

	onOperatorRatesMobile(operator) {
		return generateUrl(routes.OperatoryTariffs.route, {
			operator: operator.url_name,
			regionUrl: operator.region.url,
		});
	}

	onProviderConnect(provider) {
		let {
			ApplicationModel: { tariffsModel },
		} = this.props;
		tariffsModel.setProvider(provider);
	}

	onFormComponent(tariffs) {
		let {
			ApplicationModel: { text, windowSizeModel, ratesModel, providerModel },
			match,
			providerForCard,
			skipLayout,
		} = this.props;
		let tagCode = match.params.tagCode;
		let newForm = false;
		let brandButton = this.props.providerForCard.provider_settings?.brand_button || {};
		let presenceBrand = brandButton.mode !== "disabled";

		if (newFormList.includes(tagCode)) {
			newForm = true;
		}

		const component = newForm ? (
			<TariffsWithTagList
				{...this.props}
				text={text}
				windowSize={windowSizeModel.windowSizes}
				providers={providerForCard}
				tariffs={tariffs.data}
				onProviderConnect={this.onProviderConnect}
				onProviderRates={this.onProviderRates}
				flat={ratesModel.orientation}
				pageName="tariffs_tags_prov"
				providerModel={providerModel}
				isRatesTag={true}
				isProviderRatesTag={this.props.isProviderRatesTags}
				// TODO: rework key using to component decomposition or additional route
				key={match.params.tagCode}
				presenceBrand={presenceBrand}
				skipLayout={skipLayout}
			/>
		) : (
			<Tariffs
				tariffs={tariffs.data}
				pagination={tariffs.pagination}
				isRates={this.props.isRates}
				isProviderRatesTags={this.props.isProviderRatesTags}
				presenceBrand={presenceBrand}
			/>
		);
		return component;
	}

	render() {
		let {
			ApplicationModel: { text },
			data: { tariffs },
			match,
			tariffTags,
			providerForCard,
			operatorTag,
			seoBlock,
		} = this.props;
		let brandButton = this.props.providerForCard.provider_settings?.brand_button || {};
		let tagCode = match.params.tagCode;

		const update_date = providerForCard?.update_date;
		const filters = providerForCard?.filters;

		let sortedFilters = {};
		for (let it in filters) {
			sortedFilters[it] = orderBy(filters[it], "name", "asc");
		}

		return (
			<>
				<PaddingBottom>
					<Container>
						<TagButton key={v4()} providerButton={true} />
						{tariffTags?.length &&
							tariffTags
								.filter((x) => x.count)
								.map((tag) => (
									<TagButton
										elem={tag}
										key={tag.url}
										active={tagCode === tag.url}
										providerButton={true}
									/>
								))}
						{!!operatorTag && (
							<TagButton
								anotherUrl={this.onOperatorRatesMobile(operatorTag)}
								elem={{ name: text.SIM_CARDS }}
							/>
						)}
					</Container>
				</PaddingBottom>
				<FiltersContainer
					onMount={(filters) => (this.filters = filters)}
					filters={sortedFilters}
					isProviderCard={true}
				/>
				{update_date && (
					<Container>
						<HeaderTextSeo header={seoBlock?.seoHeader} text={seoBlock?.seoText} />
						<TariffsActualDate date={update_date} />
					</Container>
				)}
				{tariffs?.data ? (
					<>
						{this.onFormComponent(tariffs)}
						<BlockButton>
							<BrandButton
								brand_button={brandButton}
								click={"prov2"}
								typeBrandButton={"Footer"}
								providerId={this.props.providerForCard.id}
							/>
						</BlockButton>
					</>
				) : (
					<Stub />
				)}
			</>
		);
	}
}

export default withRouter(
	withDefaultParams(
		variablesFromRouter(
			graphql(TARIFFS_QUERY, {
				options: (props) => {
					let filter = props.variables.filter;
					let params = queryString.parse(props.location.search);
					if (!!params.district) {
						filter = filter + `&districts.id=${params.district}`;
					}
					let page = 1;
					if (props.match.params.page) {
						page = +props.match.params.page;
					}
					filter += "&provider.mobile_operator=0";

					let tagCode = props.match.params.tagCode;
					if (tagCode && props?.tariffTags?.length) {
						const foundTag = props?.tariffTags.find((x) => x.url === tagCode);
						if (foundTag) {
							filter += `&${foundTag.filter}`;
						}
					}
					return {
						variables: {
							...props.variables,
							house_id: null,
							limit: LimitPlansBTableContainer,
							offset: page * LimitPlansBTableContainer - LimitPlansBTableContainer,
							filter: filter,
							providerJoin: true,
						},
					};
				},
			})(TarifficationTagsList),
			"order,id"
		)
	)
);
